export { SearchTag } from '../src/SearchTag';
